
















































































































import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'applicationContainerTable'
})
export default class ApplicationContainerTable extends Vue {
  @Prop({ default: '' }) public villagesAndTowns: string
  @Prop({ default: '' }) public orgName: string
  @Prop({ default: {} }) public detailInfo: any
  @Prop({ default: '' }) public appearType: string
  // 申请相关：
  public applyAmount: string = ''
  public applyReason: string = ''

  get iconForStatus (): string {
    let iconForStatus = ''
    if (this.detailInfo.status === '已完成') {
      iconForStatus = 'icon-yiwancheng'
    }
    if (String(this.detailInfo.status).includes('驳回')) {
      iconForStatus = 'icon-bohui'
    }
    return iconForStatus
  }

  get colorForStatus (): string {
    let colorForStatus = ''
    if (this.detailInfo.status === '已完成') {
      colorForStatus = 'status_success'
    }
    if (String(this.detailInfo.status).includes('驳回')) {
      colorForStatus = 'status_turn_down'
    }
    return colorForStatus
  }
}
